export default "__VITE_ASSET__Byhf7F$v__"